






















import { IProjectSettings } from '@master/config/IProjectSettings'
import { inject } from 'inversify-props'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getChildSections } from '../pages/userProfile/route/index'

interface User {
  oid: string;
  fullname: string;
  systemrole: string;
  email: string;
}
@Component
export default class TheUserNavi extends Vue {
  @inject()
  private projectSettings: IProjectSettings

  @Prop({ required: true }) readonly user!: User

  get isBscReviewer () {
    return this.$store.getters.currentUser.systemrole === 'bsc-reviewer'
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get sections () {
    // return this.$router.options.routes.find(route => route.name === 'User Profile Main')?.children || []
    return getChildSections(this.currentUser.systemrole, this.$router) || []
  }
}

